import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL, WOODGRAIN_IMG } from "@/data/content";

export const NotFound = () => {
  return (
    <section
      data-testid="not-found-section"
      className="relative min-h-[100svh] flex flex-col items-center justify-center overflow-hidden px-6 py-24 text-center"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${WOODGRAIN_IMG})` }}
      />
      <div className="absolute inset-0 bg-[#f7f0eb]/80" />

      <div className="relative z-10 flex flex-col items-center max-w-xl">
        <div
          data-testid="not-found-404"
          className="flex items-center justify-center gap-1 sm:gap-2"
        >
          <span
            className="font-display font-bold leading-none text-[#111111] text-[8.5rem] sm:text-[11rem] select-none"
            aria-hidden="true"
          >
            4
          </span>
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 130, damping: 11 }}
          >
            <motion.img
              src={LOGO_URL}
              alt="Bobo's Donuts pink donut logo"
              data-testid="not-found-logo"
              animate={{ rotate: [0, -8, 8, -6, 6, 0] }}
              transition={{ duration: 1.6, repeat: Infinity, repeatDelay: 2, ease: "easeInOut" }}
              className="w-36 h-36 sm:w-44 sm:h-44 object-contain drop-shadow-[0_10px_24px_rgba(255,100,139,0.35)] select-none"
            />
          </motion.div>
          <span
            className="font-display font-bold leading-none text-[#111111] text-[8.5rem] sm:text-[11rem] select-none"
            aria-hidden="true"
          >
            4
          </span>
        </div>

        <p
          data-testid="not-found-code"
          className="mt-6 font-display font-bold text-sm tracking-[0.3em] uppercase text-[#ed4a76]"
        >
          Error 404 — Page Missing
        </p>

        <h1
          data-testid="not-found-heading"
          className="mt-3 font-display font-bold text-4xl sm:text-5xl text-[#111111] leading-[1.08]"
          style={{ textWrap: "balance" }}
        >
          This page is a donut hole
        </h1>

        <p
          className="mt-5 text-base sm:text-lg text-[#3d3d3d] leading-relaxed"
          style={{ textWrap: "balance" }}
        >
          The page you were craving isn't on our menu — but plenty of fresh,
          hand-cut donuts are waiting back home for you.
        </p>

        <Link
          to="/"
          data-testid="not-found-home-btn"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#ff648b] text-[#111111] font-bold text-base sm:text-lg hover:bg-[#ed4a76] hover:scale-105 transition-all shadow-lg"
        >
          <ArrowLeft className="h-5 w-5" /> Back to the donuts
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
